import React from 'react';
import { Card } from 'primereact/card';
import './stackRankCard.css';
import { RankingItem } from '../../pages/stackRank/types';
import { metricValueFormat } from '../../utils/metricValueFormat';



type StackRankCardProps = {
  data: RankingItem[];
  selectedMetric?: string;
};


export const StackRankCard: React.FC<StackRankCardProps> = ({ data, selectedMetric }) => {
  const getFilteredRanks = (data: RankingItem[]) => {
    const result: Record<number, { items: RankingItem[] }> = {};
    const firsts = data.filter(item => item.metric_rank === 1);
    const seconds = data.filter(item => item.metric_rank === 2);
    const thirds = data.filter(item => item.metric_rank === 3);

    if (firsts.length === 1 && seconds.length === 1 && thirds.length === 1) {
      result[1] = { items: firsts };
      result[2] = { items: seconds };
      result[3] = { items: thirds };
      return result;
    }
    if (firsts.length >= 3) {
      result[1] = { items: firsts };
      return result;
    }

    if (firsts.length === 1 && seconds.length > 1) {
      result[1] = { items: firsts };
      result[2] = { items: seconds };
      return result;
    }

    if (firsts.length === 1 && seconds.length === 1 && thirds.length > 0) {
      result[1] = { items: firsts };
      result[2] = { items: seconds };
      result[3] = { items: thirds };
      return result;
    }

    if (firsts.length === 2 && seconds.length >= 0 && thirds.length > 0) {
      result[1] = { items: firsts };
      result[3] = { items: thirds };
      return result;
    }

    //Default: show 1st, 2nd, 3rd with icons
    if (firsts.length) result[1] = { items: firsts };
    if (seconds.length) result[2] = { items: seconds };
    if (thirds.length) result[3] = { items: thirds };
    return result;
  };

  const ranks = getFilteredRanks(data);
  const rankCount = Object.keys(ranks).length;
  let layoutClass = 'one';
  const rankKeys = Object.keys(ranks).map(Number).sort();
  const hasSingleRanks = ranks[1]?.items.length === 1 && ranks[2]?.items.length === 1 && ranks[3]?.items.length === 1;

  if (hasSingleRanks) {
    layoutClass = 'custom-three';}
    else if (rankKeys.length === 1) {
      layoutClass = 'one';
    }
    else if (rankKeys.length === 2) {
      layoutClass = 'two';
    } else if (rankKeys.length === 3) {
      layoutClass = 'three';
    }

    return (
      <Card className="stack-rank-card rounded-edge" style={{ width: '100%', height: '100%', backgroundImage: "url('/spaceBG.png')" }}>
        {<div className="ranking-header">
        {(selectedMetric && selectedMetric.length > 0 )&& <p> {selectedMetric} Ranking <span className="arrow">{'>'}</span></p>}
        </div>}
        {rankCount === 0 && (
          <div className='no-data'> No Data <br />Available</div>
        )}

        {layoutClass === 'custom-three' && (
          <div className={`ranking-columns ${layoutClass}`}>   
          {[2, 1, 3].map(rank => (
            <div key={rank} className={`rank-column rank-${rank}`}   >
             {rank===1 && ( <div className={`planet-badge planet-1`}><img height={150} width={150} src={`/planet1.png`} alt={'1'} /> </div>)}
             {rank===2 && ( <div className={`planet-badge planet-2`}><img height={60} width={90} src={`/planet2.png`} alt={'2'} /> </div>)}
             {rank===3 && ( <div className={`planet-badge planet-3`}><img height={60} width={60} src={`/planet3.png`} alt={'3'} /> </div>)}
  
              {ranks[rank].items.map((item:RankingItem) => (
                
               rank===1 ? <div key={item.employee_name} style={{fontSize:'1.5rem',fontWeight:'bold',marginTop:'-30px'}}>
                  {item.employee_name.split(' (')[0]}
                </div>
                :
                <div key={item.employee_name}>
                  {item.employee_name.split(' (')[0]}
                </div>
                
              ))}
  
              <div >
                {metricValueFormat( ranks[rank].items[0]?.metric_value, data[0]?.metricType ?? '')}
              </div>
              
            </div>
          ))}
          </div>
        )}
        {layoutClass !== 'custom-three' && (
          <div className={`ranking-columns ${layoutClass}`}>            
            {Object.keys(ranks).map(rankKey => {
              const rank = Number(rankKey);
              return (
                <div key={rank} className={`rank-column rank-${rank}`}>
                  {rank === 1 && <img src="/planet1.png" alt="1" width={150} />}
                  {rank === 2 && <img src="/planet2.png" alt="2" width={90} />}
                  {rank === 3 && <img src="/planet3.png" alt="3" width={60} />}
                  <div className="scrollable-content" style={rank === 1 ? { marginTop: '-30px'} : {}}>
                    <div className={`agent-list ${rankCount === 1 && ranks[rank].items.length > 3 ? 'two-column' : ''} ${rankCount === 1 && ranks[rank].items.length <= 3 ? 'single-column' : ''}`}>
                      {ranks[rank].items.map(item => (
                        <div
                          key={item.employee_name}
                          className="agent-name"
                          style={rank === 1 && ranks[rank].items.length === 1 ? { fontSize: '1.5rem', fontWeight: 'bold' } : {}}
                        >
                          {item.employee_name.split(' (')[0]}
                        </div>
                      ))}
                    </div>
                  </div>
                  <div>{metricValueFormat(ranks[rank].items[0]?.metric_value, data[0]?.metricType ?? '')}</div>
                </div>
              );
            })}
          </div>
          )};
          <div className="ranking-footer">
            <div style={{ margin: '3rem' }} />
          </div>
        
      </Card>
    );
  };